import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { DELIVERY_ALERT_TYPES } from '../../../delivery-alerts/alertTypes';

export function EmergencyAlertModal({ open, onClose, onSubmit, loading }) {
  const [selectedType, setSelectedType] = useState('');
  const [message, setMessage] = useState('');

  if (!open) return null;

  const selectedAlert = DELIVERY_ALERT_TYPES.find(item => item.value === selectedType);

  const handleSubmit = async () => {
    if (!selectedType || loading) return;
    const ok = await onSubmit({
      alert_type: selectedType,
      message,
    });
    if (ok) {
      setSelectedType('');
      setMessage('');
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 2000 }}>
      <div className="absolute inset-0 bg-black/50" onClick={loading ? undefined : onClose} />
      <div className="bg-white rounded-2xl w-full max-w-lg relative max-h-[90vh] flex flex-col">
        <div className="border-b border-gray-200 px-5 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-red-50 text-red-600 flex items-center justify-center">
              <AlertTriangle className="w-5 h-5" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900">Alertar incidencia</h2>
              <p className="text-xs text-gray-500">Se notificara en tiempo real</p>
            </div>
          </div>
          <button
            onClick={onClose}
            disabled={loading}
            className="p-2 rounded-lg hover:bg-gray-100 disabled:opacity-50"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-5 space-y-4 overflow-y-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {DELIVERY_ALERT_TYPES.map((alert) => {
              const isSelected = selectedType === alert.value;
              const severityClass = alert.severity === 'high'
                ? 'border-red-300 bg-red-50'
                : alert.severity === 'medium'
                  ? 'border-amber-300 bg-amber-50'
                  : 'border-slate-300 bg-slate-50';

              return (
                <button
                  key={alert.value}
                  type="button"
                  onClick={() => setSelectedType(alert.value)}
                  className={`text-left p-3 rounded-lg border-2 transition-all ${
                    isSelected ? severityClass : 'border-gray-200 hover:border-gray-300 bg-white'
                  }`}
                >
                  <div className="font-semibold text-sm text-gray-900">{alert.label}</div>
                  <div className="text-xs text-gray-500 mt-1 leading-snug">{alert.description}</div>
                </button>
              );
            })}
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-800 mb-2">
              Comentario opcional
            </label>
            <textarea
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              placeholder="Agrega un detalle corto si ayuda a resolverlo mas rapido"
              className="w-full h-24 px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-brand-primary focus:outline-none resize-none"
            />
          </div>

          {selectedAlert && (
            <div className="rounded-lg bg-slate-50 border border-slate-200 p-3">
              <div className="text-sm font-semibold text-slate-900">{selectedAlert.label}</div>
              <div className="text-xs text-slate-600 mt-1">{selectedAlert.description}</div>
            </div>
          )}
        </div>

        <div className="border-t border-gray-200 p-5">
          <button
            onClick={handleSubmit}
            disabled={!selectedType || loading}
            className="w-full bg-red-600 text-white py-3 rounded-lg font-semibold hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <AlertTriangle className="w-5 h-5" />
            )}
            Enviar alerta
          </button>
        </div>
      </div>
    </div>
  );
}
